export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAIL = 'SIGNUP_FAIL';
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS';
export const ACTIVATION_FAIL = 'ACTIVATION_FAIL';
export const USER_LOADED_SUCCESS = 'USER_LOADED_SUCCESS';
export const USER_LOADED_FAIL = 'USER_LOADED_FAIL';
export const AUTHENTICATED_SUCCESS = 'AUTHENTICATED_SUCCESS';
export const AUTHENTICATED_FAIL = 'AUTHENTICATED_FAIL';
export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_CONFIRM_SUCCESS =  'PASSWORD_RESET_CONFIRM_SUCCESS';
export const PASSWORD_RESET_CONFIRM_FAIL = 'PASSWORD_RESET_CONFIRM_FAIL'; 
export const LOGOUT = 'LOGOUT';
export const SETTING_POST_REQUEST = 'SETTING_POST_REQUEST'
export const SETTING_POST_SUCCESS = 'SETTING_POST_SUCCESS'
export const SETTING_POST_FAIL = 'SETTING_POST_FAIL'


export const ADD_SURAH_SUCCESS = 'ADD_SURAH_SUCCESS';
export const ADD_SURAH_FAIL = 'ADD_SURAH_FAIL';
export const ADD_SURAH_REQUEST = 'ADD_SURAH_REQUEST';


export const GET_SURAH_SUCCESS = 'GET_SURAH_SUCCESS';
export const GET_SURAH_FAIL = 'GET_SURAH_FAIL';
export const GET_SURAH_REQUEST = 'GET_SURAH_REQUEST';


export const EDIT_REVIEW_SUCCESS = 'EDIT_REVIEW_SUCCESS';
export const EDIT_REVIEW_FAIL = 'EDIT_REVIEW_FAIL';
export const EDIT_REVIEW_REQUEST = 'EDIT_REVIEW_REQUEST';



export const SHIFT_TOMORROW_TODAY_SUCCESS = 'SHIFT_TOMORROW_TODAY_SUCCESS';
export const SHIFT_TOMORROW_TODAY_FAIL = 'SHIFT_TOMORROW_TODAY_FAIL'
export const SHIFT_TOMORROW_TODAY_REQUEST = 'SHIFT_TOMORROW_TODAY_REQUEST'


export const DELETE_REVIEW_SUCCESS = " DELETE_REVIEW_SUCCESS"
export const DELETE_REVIEW_REQUEST = " DELETE_REVIEW_REQUEST"
export const DELETE_REVIEW_FAIL = " DELETE_REVIEW_FAIL"


export const POSTPONE_TODAY_SUCCESS = " POSTPONE_TODAY_SUCCESS"
export const POSTPONE_TODAY_REQUEST = " POSTPONE_TODAY_REQUEST"
export const POSTPONE_TODAY_FAIL = " POSTPONE_TODAY_FAIL"


export const POSTPONE_ALL_REVIEW_SUCCESS = " POSTPONE_ALL_REVIEW_SUCCESS"
export const POSTPONE_ALL_REVIEW_REQUEST = " POSTPONE_ALL_REVIEW_REQUEST"
export const POSTPONE_ALL_REVIEW_FAIL = " POSTPONE_ALL_REVIEW_FAIL"

export const CHANGE_ALL_SURAH_TO_REVIEW_SUCESS = 'CHANGE_ALL_SURAH_TO_REVIEW_SUCESS'
export const CHANGE_ALL_SURAH_TO_REVIEW_FAIL = 'CHANGE_ALL_SURAH_TO_REVIEW_FAIL'
export const CHANGE_ALL_SURAH_TO_REVIEW_REQUEST = 'CHANGE_ALL_SURAH_TO_REVIEW_REQUEST'

export const SAVE_SURAH_AS_COMPLETE_SUCCESS ='SAVE_SURAH_AS_COMPLETE_SUCCESS'
export const SAVE_SURAH_AS_COMPLETE_REQUEST ='SAVE_SURAH_AS_COMPLETE_REQUEST'
export const SAVE_SURAH_AS_COMPLETE_FAIL ='SAVE_SURAH_AS_COMPLETE_FAIL'


export const GET_REVIEW_SURAHS_SUMMARY_SUCCESS = 'GET_REVIEW_SURAHS_SUMMARY_SUCCESS'
export const GET_REVIEW_SURAHS_SUMMARY_FAIL = 'GET_REVIEW_SURAHS_SUMMARY_FAIL'
export const GET_REVIEW_SURAHS_SUMMARY_REQUEST = 'GET_REVIEW_SURAHS_SUMMARY_REQUEST'


export const GET_STATISTICS_SUCCESS = 'GET_STATISTICS_SUCCESS';
export const GET_STATISTICS_FAIL = 'GET_STATISTICS_FAIL';
export const GET_STATISTICS_REQUEST = 'GET_STATISTICS_REQUEST';

